import { DiscountKind } from '@skylab-shared/dataModel';

export function applyDiscount(amount: number, discountKind: DiscountKind, discount: number): number {
    return discountKind === DiscountKind.Percentage ? amount * (1 - discount) : amount - discount;
}

export function removeDisocunt(amount: number, discountKind: DiscountKind, discount: number): number {
    return discountKind === DiscountKind.Percentage ? amount / (1 - discount) : amount + discount;
}

export function applyTax(amount: number, taxRate: number): number {
    return amount * (1 + taxRate);
}//gross

export function removeTax(amount: number, taxRate: number): number {
    return amount * (1 / (1 + taxRate));
}
